export const defaultDatabase = [
  {
    label: '1,4-elimination',
    rxnCode:
      'gGP`DTjZj`OdhLQRPPBB``D@!eMHJM`qiA@H@ eMHJM`qiA@H@#qrka quX qTH#!Rb@Jw@gx?_`BH_Qvr@` !R_qL@XqvZO@ !R_qL@XquzO@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'diDD@LiJf_jjh@~KHjFchbfHHAEHHA@!gGP`HTkej`OhXbh``DEA@H@ eM@HvB#IJlX^RX IIjGi Q^#!Rm?wp?PD@mwq~_?A|m?wp?QuRo@ !R}pOp?_A|_g?p?QtzW@ !ROvL@XqtFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gChA@Icu@YPOYQ^`bNB\\GaHXECAjb@!fJ@FLgAx@ fHT`P#Q`P a` QP#!ROg?Po[^}G_H| !RGUi| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eFH`fLFTOzLcBB@P!fI@GudYA@H@ fHT`P#Qd a` QP#!R@BL]\\gp !RGUi| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eMhdYRRCJW}N@!fJ@D eFH`fND#Qg Qp Qd#!R@Fp@HqvJ_@ !RGUi| !R@BL]ngp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eMDaYRRCJW}LQeA@H@!fI@FL``D@ eFH`fND#Qg Qp Qd#!R@Fp@PqvJ_@ !RGUi| !R@DL]^gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'dayHBDxDeIYtjj@OdRJ`!gCi@DDeZ@~b` gChA@IRVdCzB@#IyjH\\R@ IyjD qbq#!R|Gsp?_A|_g?p?_A||Ot]|kp !R@FL@[@AcGSi| !R@FL@[@AcGXY|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4',
    description: 'Fig 23 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBCDcAcBQFIdT!eFBcDIcA}EqaHcD@#QX QX#!R@FL]bgp !R@FL]vgp',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'daDD@DqJg^ffZh@qQDD@cDD@`!gGQ@BeJmJHGFEA@H@ eFHBJFLHHA@#IGmdehp IxakS IeP#!R_g?w@oB||Kwp?_A||Ot]lkp !R|OtA@OA|}pKp?QwZ`` !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFp@DiTujhB!gC`@Die@` eF@HhP#q]aV q]a Q\\#!R?g~w@k_}m?vw@auRO@ !R@Fq?[@@SGUk| !R@AL]^kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFx@@eJfuS@P!gC`@Die@` eF`BJD#q]aV qqU q\\#!R?g~w@k_}m?vw@auRO@ !R@Fq?[@@SGUk| !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gOu@AReLm]SLAcB``D@!gJY@@TeVTCFEA@H@ eF`BJD#IKJRV` IZDrP qM#!R}xOp?Wy?}?q~_?B}GYI\\ !R_qq?Dw|\\_qp]z`H !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@DeZu@_PqFIA@HFB@!eMHJM`qiA@H@ eF@HhP#qeVH qbh qq#!ROvM@DpAl@FL]bcp !R_qL@XqwZO@ !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gNpiIahRTeVfjDe}KDYDD@`!gC`iIahRTefDe}MDYDD@` eM@HvB#qbqkx qar qkx#!RbOvH@hc}b@K~@Hc}G_K| !R@AL@[@@SG[j| !R_qL@DqtFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene (Claisen rearrangement)',
    rxnCode:
      'daxH@JrRHiMUHAcEHHA@!daxH@NrSRHmUHAcGHHA@#IZaxla@ IhfP^c@#!RmwvH_Wx@mpJw_]\\Buwt]Dgp !R@FM?Dw|\\[C}cOw|S_qp]vcp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gJQ@HeZu@_PqFQA@H@!eMHJN`~jHt``D@ eF@HhP#qMr` qMp Qd#!R_qL@XpAl@FL]Bcp !R_qL@XqwZO@ !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daxDBDqIRiubJ`CZN|bPtQqDD@cDD@chXO}c`!gJQ@DeNl`XqHHA@ eFH`fLGtYFDD@`#qqj\\x qqkx QX#!RbKvAHI^}b@JW@kx@e{t]dop !R@BM?W@Al@BL]nop !R@BL]agp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGY@DDf]j`Odkl@!gCi@DDff@~`l eF@HhP#qrLk qrL qk#!Rb@JH?_x@b@JH?QuJ@` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daDLBHSdeJmVfZjh@~QHzHyBB@PbB@QrB@P!gCaAIiRmhCFQA@H@ gC``Eh{PGrTZHiHHAFPPB@#Ikb[HPP I`Tp qky#!R}?spoGy?|OwpoWy?_g|]tep !R_qp@[@AcGUk| !RbGvw?Wx@G_k|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`MTj}jPOihbl``DUA@H@!eMHJMPqiA@H@ eMHFM`~fHr``D@#qStM qTX qNh#!RbGvw_Wx@mpJw?QvR?@ !R@@E?_awz_@ !R@FM?DquZO@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aromatic elimination',
    rxnCode:
      'ded@@DiUU`hJ@H!gFp@DiTt@@B gC`@DiZDC@#IpdjFGiT qcUq IGiT#!RbKwWoX`B_c}~@M^}bOq~Owx@GWJ| !R_g~w_K_}m?vw_AvZO@ !R|Gq~_?C}GPZ|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.6',
    description: 'Fig. 16',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFp@DiTvjhB!eF@HhP eF@HhP eF@HhP#qcUq Qd qk qN#!R?g~w@k_}m?vw@avRO@ !R@AL]Fkp !R@AL]Nkp !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFpAAJTj[UTA@!eF@bXhP eF@HhP eF@HhP#q\\jN q] qN Qd#!R?g~w@k_}m?vw@avRO@ !R@AL]Fgp !R@AL]Nkp !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sigmatropic rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvB#Q^ Q[#!R_qL@DquJO@ !R_qL@Dqtzo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMHJN`pksPqFdD@`!fI@GudYA@H@ eF@HhP#Q^ Qp Qd#!RWrL@@qvrO@ !RG]i| !R@@L]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'gGYADEJSLuPGtT_nlK|!gChA@Icu@_PP eFHBND#qtSi qQ] Qx#!RbOvH@oy??`BH?QtJo@ !Rm?w~@Hc}GUk| !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7.1.3',
    description: 'Fig. 22 c. ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNpaIYJU_MU@_JQXbh``DUA@H@!gCa@IGj@~dbLbB@P eMHjfM`~jHt``D@#qqWeX qqW qeX#!RmwvH_Wx@b@I~@Ha}G[K| !Rm?u~@Ha}GUi| !R_qL@XquzO@',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNxaLJIRU[jXCzZ@!eMH`eIxH eF`BJGtP eFHBND#q{iV` Qv qM q{#!R?g?~_xc}b@K~@Hc}G]H\\ !R_?y??auj_@ !R@AL]ngp !R@AL]Agp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ@!gC`HAxQz`H eM@fXvB eF@HhP#IaLJfxY qan IF^ qS#!R@AMl@G}lDw|@[@@S@Fp@Dqvr_@ !Rm?w~@Hc}GYk| !R_qL@DquzO@ !R@AL]akp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote hydrogen rearrangement',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ}DP!gGPIAxBTjfjPH eM@HvB#IZnFRqH IZagb Q^#!R@AMl@G}lDw|@[@@S@Fp@Dqwr_@ !R@FpS@G|S[G|@Dqtz_@ !R_qL@DqtFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGYALMJT}TpGRdX!gJY@DDefXB fHT`P#qnZa qnTH qX#!RbOvw?X`B?`BH?Qur?@ !RbOvH@ox@bOt]Nop !RG_i|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'dazHBLCIRfVjY`CiBfoQT@!gGYADEJSLtpD eF@HhP#IqBZJG` IqF`^ qM#!RbOvw?X`B?g~w@ox@bOt]lkp !RbOvH@oy??`BH?Qvzo@ !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dioxolane fragmentation',
    rxnCode:
      'dclDB@iYRfUw\\kahHBj@CzI`!eFHBJD deTHB@RTfU]ih@I`Hz~`H@#IzAQirbWS IdP IzD[JI]L#!Rim~?Sk]}bGwMs?y??g~H_Xa}b@JH_QwR{@ !R@AL]agp !Rb@K~@Hc}b@JH@hc}bOvH@hc}GWjB',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1002/jms.1963',
    section: '',
    description: 'Fig. 4',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'eM@jXvCFdD@`!fH@Oj@ eF@bXxXp``D@#Qg Qp QX#!R_qL@DqtrO@ !RGUi| !R@AL]ngp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.1. b',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gC`a@aJRm@_PP!eMHAIhOh` eFH`fND#qbq qq@ Qd#!R@AL@[@@SG_I| !R@Fp@DqwZ_@ !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'http://dx.doi.org/10.1088/1468-6996/10/3/034602',
    section: 'Results',
    description: 'Fig. 5',
    kind: 'reaction',
    web: 'https://www.researchgate.net/figure/a-Chemical-structure-of-oxidative-reserpine-MW-6077-b-Post-source-decay_fig4_26637371',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJXA@IRUjPH!eM@fXvB eF`BLGtP#qlVH qrH ql#!R@Fp@DpAl@AL]Bgp !R_qL@DqwZO@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJQABYRmZ`LXTD@`!eM@fXvB eFH`fLGtQFDD@`#qMr` qNh Qd#!R@FM?Dw|\\_qL]dcp !ROvL@XqwZO@ !R@FL]~gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gCaA@IRmhCzZHpHHA@!eFH`fJGtQFDD@` eF@HhP#qqT qq Qd#!ROvp@[@AcGPi| !R@FL]vgp !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'eMHJN`~ZFHt``D@!fI@GudYA@H@ eF@HhP#Q[ a` Qt#!R_qL@XqwrO@ !RG]i| !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 a. & b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'dcN@B@J\\bRbRaWCUUUL@_ITC@!gFpAEJTjZuRA@ eM`AIhH eM@HvB#IO^adkBFU qb^i IO^ IeQ#!RbGvH@ha}bOs~_xa}bGw~_xc|?`BH?Awro@ !R?g~w@k_}m?vw@atZo@ !R@Fp@Dqwz_@ !R_qL@DqvFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'didDB@{iRYefxiJH@zRhX!gNpaAQJRs\\dBIzQg@ eF@HhP#IwlDdeZ IwlIEh IFP#!RbCvH?Ky_bCv~@H`}oe~H?Awro@ !Rmwvw_[y?msrpo[^}GSh\\ !R@BL]fkp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'fdeA`D@\\brTfYY_m]gIZ|DhJB@@h@@~aF@!didHB@BTfUvfZVV@OhB@ didD@@iIYgxUie`B#iup`jXdibCPcXKoI iSxKhvMHP IwbkEYH#!RbKvH?Gx?bKu~@Hb}_c~H?Hc|_c}~@Hb}u{u~Owx?uwu~OquRS@ !R|GwpoGy?|GwpoWy?|GwpoQwZg@ !Rm?vw?Wy?mwsp_[]}m?vw_AuzG@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'deTDB@{iRYemnJPb`CiJaoQt@!gGPa@QJRmsPbX gC`@DiPDCteZ@#IaLJfxYT IaBxU IriX#!RbOvH?Oy?bOw~@Ha}?g~H?Oy?G[I\\ !RbOvH?X`B?`BH?Qtz_@ !Rb@K~_xc}GXX|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Elimination',
    rxnCode: 'eMHAIhOdm`!fI@Guh eF@HhP#Qg a` Qt#!R@Fp@XqvJ_@ !RG]i| !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Halide Elimination',
    rxnCode:
      'eMBGDchOjbLiDX`!fHfHA}QFRHq@ eF@HhP#Q[ Qp Qd#!R_qL@TqurO@ !RGUi| !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gGYADEJSNuPD!gCiADEJSM@_QP eF@HhP#qbq_ qbq q{#!Rb@JH?_x@b@JH?QvJ@` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHbeIXH eFHBLGtX#qrLh Qv qM#!R`W~GkQSuavH]tep !R`W}LeQvZW@ !R_rP]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC`a@eJSM@_QX eF@HhP#satpj satp qi#!RbOrH_Wx@b@JH_QtJ`` !Rb@JH_Wx@GSjB !R_rp]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 12',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC``@dfZ@~b` eF@bXpP#qbqk qbq qk#!RbOrH_Wx@b@JH_Qwr`` !Rb@JH_Wx@GSjB !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 13',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSJuPGtT@!gC``@deZ@` eF@bXpP#qbqk qbu qK#!R_`CW?Hc|uwvH_QwR`` !R@FL@[@AcGSj| !R_rp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 14',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHAITH eFH`fLGtX#qbqh qbH qu#!RbOvH@oy?bOt]|mp !R_?y??atZ_@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 15',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gJXaLDiRYZ`Ohh@!eMhdiRVB eFHBLGtP#qbqh qbH qu#!RbOvH@oy?bOt]Bmp !R@Fp@DqwZ?@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 16A & B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gJXaLDiRYZ`Ohh@!eMhDRUB eFH`fLGtX#qbqh qbH qu#!RbOvH@oy?bOt]|mp !R_?y??atZ_@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 17',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gGXaLDiRYvj@~b`!gChaLDiRYhCzK@ eF@HhP#IaLJa qbq IF`#!ROg?PO[\\}tEsP?Qvrg@ !RtGt~_}@|G[j| !R_pp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 18',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gJYIC`DBTijXCzB@!eMhdiRVB eFB@HcA}D@#qbqh qJh Ql#!Rb@Jw@ox@bOt]\\hH !R@Fp@DqwZ?@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 19',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'daF@B@BTeeVz`@@B!gOpAMJUKua@@D fJRPH#IGfbdK@ q\\oQp ID#!RmpJw?_y?mpJw?[_}mpH]Dcp !Rmww~@Ha}mpJw@ox@GUk| !RG_i|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'did@BLeJeWk``b@CzAbLMcApB@!gOpAMJUKua@@D eF@HhXqcApB@#IZJyBGI q\\oQp IFP#!Ri}w^@Hc]i?rg@h`Bw`BHwQur@` !Ri}w^@Hc]i?rg?Mx@G]hB !R@@L]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'dif@B@BTeYWaz@@@OhB@!gOpAMJUKua@@D eF`BND#Id^ZJPl q\\oQp IdP#!R?`C~@K\\Bmww~@K\\BmpK~@AuRh` !Rmww~@Ha}mpJw@ox@GUk| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'didHB@BTiyWaj@@@OhB@!gOpAMJUKua@@D eFHBLGtP#IGiZJPl q\\oQp IFP#!Rm?vH?[\\Bm?w~@K\\BmpK~@Awb@` !Rmww~@Ha}mpJw@ox@GUk| !R_vp]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'dmtDB@PIRY^UeVj@@@OhB@!gOpAMJUKua@@D gC``@deZ@`#IaLJfxYWP I[aJUt qbu#!R?`Bw@h`Bm?vH?Xc|?g~H?Xa}?g|]LhH !Rm?w~@Hc}mpJw@ox@GUk| !R@AL@[@@SGXY|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gGYIC`DBTiff`OhH@!gCiIL`DBTff@~`p eF@HhP#IaLJa qbM IG@#!RmpJH@k_}?`BH?Qtr`` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 20',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gNyIC`DF\\dTJij@~a`!gJYHC`DISTpGtL@ eF@bXpP#IaLJnD qbqh IxP#!Rb@Jw@ox@bOvH@hc}GWJB !Rb@Jw@ox@bOt]NhH !R@AL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 21',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gGYIC`DB\\dTMM@_PP!gCaHL@aJZPH eF``fJGtP#qbqo qbq qo#!RbOvw?_y?b@JH?Qvrw@ !R@Fq?[@@SG]i| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 22',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGrDZHpypB@P!gCh@@eKHFLv\\@`D@ eF``fLGtX#qn\\J qfQ qk#!RbOvw?X`B?g~H?Qurw@ !R_?xBbG?~GYk| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 23',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGrDZHpypB@P!gCh@@eKHFLv\\@`D@ eF``fLGtX#qbu_ qj{ Ql#!R|Gvw__A|_g?p_Qvrw@ !R_wy||G}~GQk| !R@FL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 24',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGtDQas`D@`!gJT@AdijdCzZHpypB@P fHT`P#qbqo qJ|h Qp#!RbOvw?X`B?g~H?Qurw@ !Rb@Jw@ox@bOt]vhH !RG_i|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 25',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGtFQas`D@`!gChAAIRfdCF[N@PB@ eF`BLGtX#qj|^ qbs qo#!Rm?vH?[\\B?g~w?QvRw@ !R@Fq?[@@SG]k| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 26',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'day@B@HIRigjf`Cy@`hcEYpB@P!gGTAAaJTwTpGrFZHpypB@P eF@HhP#IaLJfxP IaBia q~#!RbOvw?_x@b@K~_{\\BbOt]lcp !RbOvw?X`B?g~H?Qtzw@ !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 27',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTfUfjX@~QLr@!gJU@E`dru@_SX eMHbeIXH#IZbyAr@ IZnHP Qv#!R_`CW?Hc|uwvH_Wx?u?p]dhH !R_`BH?M_|bGt]vhH !R_rq?Dqwz?@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 28',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'gGTaEaUJSNuHGrVZ@!eMhdYRVCz^@ eMhDRUB#qyuS qZp qyh#!Rb@JH?_x@b@JH?Qur`` !R@Fp@DqwZ_@ !R_?y??auz_@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 29',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gChA@IRfhB!eF`BLD eF@bXpP#qLZ qK Qd#!RhBr^_zA]GPj| !R@Gt]Vgp !R_uP]nop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTf[VjX@~QHr@!gGTaEaUJSNuHGrVZ@ eF@HhP#IaLJfEP IaLJa IU`#!Rb@JH?_x@?g~H@k_}bOt]|gp !Rb@JH?_x@b@JH?QtF`` !R@AL]fkp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 30',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode: 'eMH`eIXOh`!fH@Oj@ eFHbfJD#Qg Qp Qd#!R@Fp@Dqwr_@ !RGWi| !R@AL]Vkp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode:
      'eMH`eIXOh`!fHT`P eMHAIXOj`#qNP QP qN@#!R@Fp@Dqwr_@ !RGWi| !R@Fp@DqwZ?@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 32',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode: 'eMH`fN`~b@!fHT`P eFHBLGtP#Qg QP Ql#!R_qL@Dqur_@ !RG[i| !R@AL]Vgp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 33',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'gCaA@IRfhCiQs{BIF`!eFH`fLGtX eF@HhP#qVa QX qN#!R@Fq?[@@SGXk| !R@AL]vgp !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 34',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'eMH`fN`~RJ@!fH@Oj@ eFH`fJGtP#Q[ Qp QX#!R_qL@Dqvro@ !RGWi| !R@AL]Vgp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 35',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Oxime-ethers fragmentation',
    rxnCode:
      'gCiAHIJTt`_JPh@!eF``fJGtX eFHBJD#qbq qQ Ql#!R@Fq?[@@SGWK| !R@AL]Vgp !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 36',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gNpYHlQxR\\ddqZj@~Tap!gJPYHlQxRX}j@~TaP eF@HhP#qbuKx qbqh q{#!RDw|@Dw}l[@@@[@@SGPi| !Rm?w~@Oy?bOt]vgp !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 37A&B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gGPYHlQxJTjmj`Ohh@!gCaiHlO@SGZ@` eFHBLGtP#IaLJa qbi IpP#!R[G|@[G|SDp@@Dqvr_@ !Rm?w~@Hc}GUk| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 38',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gChA@IRfhCyBM@!eF``fLGtX eF@HhP#qbq Ql qQ#!R@Fq?[@@SGPi| !R@AL]vgp !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 4 ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gGPYHlQxJTjmj`OlhtF@!gJPXHlQxQ{TA}eF`p fHT`P#qqU\\ qqUX a`#!R[G|@[G|SDp@@Dqvr_@ !Rm?w~@Oy?bOt]vgp !RG_i|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 40',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gGPiHaxJ\\ddKU@_QYFEF@P@!gC`iHaxJX{PGrDKHsHpB@ eF@HhP#qqZl qq] Qd#!R[G}?DpAlDp@@Dqvr_@ !Rm?w~@Hc}G]k| !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 41&42',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gGQiHlOASddeZhCyKM@!gCahHlOBNtA}aBcP eF@bXpP#qVLk qVa qk#!RHpAlWu|c@Fp@Hqvr_@ !RoY\\@okvHG]i| !Ry`@]^`H',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 43',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gJQiHlOASGmPGrVZ@!gC`iHaxBX{PGtT@ fI@Gu`#qbqh qbM Qp#!Ruwu~@Gx?bGt]Lgp !Ruwu~@Ha}GYk| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 44',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gGQeEb@b^BeIiZhCzJ@!gC`eE`DSpdiLtA@ eFHBLGtP#qbqk qbM qs#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Hc}G]jB !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 45',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gNqeEb@b^BgHiDVj`Ohh@!gJQeEb@b^BeIij@~bp eF@HhP#qbqkx qbqh q_#!R[@@@Dw}l[@@@[@@SGPiB !Rb@K~@Oy?bOt]N`H !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 46',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'daxLRDp`BH|DgHiDbuU@GtI@!gGPdE`DSpRYvi@~d` eFH`fLGtX#IaLJfxP IaBka qs#!R[G}?Dp@S[@A?[@Al@AL]lmp !Rb@JH?_x@b@JH?Qvz`` !R@AL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 47',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gGQeEb@b^BeIiZhCzJ@!gC`eE`DSpdiLtA@ eFHBLGtP#qbqk qbM qs#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Hc}G]jB !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 48',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gGQeLZ@b^@eJZihCzB@!gJQdEb@b^BSTtA}A@ fHT`P#qbqk qbMX Qp#!R_qL@Dvq?_qLS@AtrO@ !Rb@K~@Oy?bOt]v`H !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 49',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gJXA@IRij`OhH@!gChA@Icm@P fH@Oj@#qrM` qri a`#!Rm?w~@Hc}mpH]Lop !Rm?w~@Hc}GUk| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 5',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gNqeLZ@b^@eJZZZ`OhH@!gJQeEb@b^@eIjZ@~`p eF@HhP#qbqkx qbMX q~#!R_vp@[AM?_vql@@@SGSHB !Rb@K~@Oy?bOt]N`H !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 50',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gGQeLZ@b^@eJZihCzB@!gCaiHlO@SGZ@` eFB@HcA}D@#qbqk qQ] Ql#!R_qL@Dvq?_qLS@AwRO@ !Rm?w~@Hc}GUk| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 51',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gJPlLPDSpPPdtu@_QP fHT`P#qbqk qbqh qX#!RDp@@[G|SDp@@DqvrP` !Rb@K~@Oy?bOt]v`H !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 52',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gC`eE`DSpdiLtA@ eFB@HcA}D@#qbqk qbM qs#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Hc}G]jB !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 53',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gJPmLPDSpPQIRZV`H fH@Oj@#q`qk qpeH qX#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Oy?bOt]v`H !RG_i|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 54',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'gGXiMDOCSddajXCFEA@H@!gC`iHaxBX}HFLrB@P eF`BLD#qbqk qbu qK#!RDpA?DpAl[G|@Dqvr_@ !Rm?w~@Hc}GUk| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 55',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'dazDbLa@|LeJi~ij@OdrNbLD``D@!gC`hHaxQvPOhHcL``D@ eF``fLGtX eF@HxP#IaLJnXP qbu qK IxP#!R@ALS@G|S[@@@[G}l@AL]top !Rm?w~@Hc}GUk| !R@AL]^gp !R@AL]Qkp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 56',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'gNxiMDOCSddauSPGrtNHphHA@!gJXiMDOCSGuHGtvQaPPB@ eF@HhP#qbqkx qbqh q_#!R[@A?[@@SDw|@[@@SG_I| !Rm?w~@Oy?bOt]Ngp !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 57',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminodithiophosphate fragmentation',
    rxnCode:
      'gGYMC`DSphPIRfji@~`bLjB@P!gCiEEAxXHDqzPLYdD@` eFB@HcA}D@#qrYl qQl qs#!R_qL@Dw|SDpAl_qwRO@ !R?`BH?[_}GUk| !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 58',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonates fragmentation',
    rxnCode:
      'gJQiHlOBSGmPGtd@!gCahHlOBOTA}I@ fHT`P#qbqh qbq qh#!Rm?w~@Oy?bOt]Lgp !Rm?w~@Hc}GUk| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 59',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gJYADEJSKTAkLh!eMHbeIXH eF`BLFlJ@#qbqh qbH qu#!RdKvPGMy?dMt]Bcp !R@Fp@@qwZ?@ !R@@L]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 6',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphonates fragmentation',
    rxnCode:
      'gJPeE`DSpTiMMPGtT@!gC`eE`DSpdiLtA@ fH@Oj@#qbNh qbN qh#!Rb@K~_?x@bOt]Rgp !RmpJw?_x@GWk| !RG]h|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 60',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfides fragmentation',
    rxnCode:
      'eMB`HIchOh`!fHT`P eFB@HcA}D@#Q[ a` Q\\#!R_qL@Dqwr_@ !RG[i| !R@AL]Vgp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 61',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfides fragmentation',
    rxnCode:
      'gC`I@DBTij@~``!eFB`HIcA}F@ eF@HhP#qrL qq Qd#!RWrL@Hu}lG[I| !R_tp]Vgp !R_tp]nop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 62',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gGXiMD@cSddaVhCz[@!gC`iH`DBXzpD eF`BLGtX#qqj\\ qqk QX#!R[@@cWu}l@BM_HquR_@ !Re{vHo[x@GYk| !R_tp]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 63',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'dcMDbLvD@Hr\\ddJfRtjmP@P@_If[@!eF``fLGt\\ deVD`Ia@BLdabRwBkRs@D#IaLJf{QVS qK IaLkmEYL#!R@k_}mx`BmpJH?[_}?`Bw?K\\B?`Bw?Aub@` !R@AL]fgp !Rm?w~@Hc}bOs~_xc}bGw~_xc}GXX|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 64',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gGXiMD@cSddaVhCy[C@!gC`hH`DQuPH eF``fLGt\\#qbqk qbu qK#!R[G|S@@Al_qL@Dqvr_@ !Rm?w~@Hc}GWk| !R@AL]Vgp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 64',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfoxides fragmentation',
    rxnCode:
      'eMJhBBXvCyH\\@!fHT`P eFJHBHh_Q@#Qg Qp Qd#!R_qL@Dqwro@ !RGWi| !R@AL]vkp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 65',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfones fragmentation',
    rxnCode:
      'gC`iH`DRXzpGrdZ@!fHT`P eMFI@bM`~f@#qbq qH Qm#!Ruwu~@Ha}G[K| !RGYi| !ROvL@Xquzo@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 66',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfones fragmentation',
    rxnCode:
      'gC`iH`DRXzpGtd@!fHT`P eMFI@bMP~b@#qfQ qH Qm#!R?`Bw?Xc}G[K| !RGQi| !R@Oy??avz_@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 67',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfites fragmentation',
    rxnCode:
      'gJQiHl@aReVu@_QP!gCahHl@bNtA}E@ fHT`P#qbqh qbq qh#!RmpJH@oy?bOt]lkp !Rm?vH?_x@G]k| !RG_i|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 68',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gJYADEJSKTAkLh!eMHAITH eF``fLGtQVE@#qbqh qbH qu#!RbOvH@oy?bOt]|mp !R_?y??atZ_@ !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gCiADEJSM@P!fHT`P eMhDRVB#qbq qH Qg#!Rb@K~@Hc}G_JB !RG[i| !R@Fp@DqwZ_@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 8',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gJYADEJSKTA@!gCi@DDfZ@` fHT`P#qbsH qbs qH#!RbOvH@oy?bOt]Bmp !Rb@K~@Hc}G]jB !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 9',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGPiH`DZ\\ddJu@XsHp\\@!gC`iH`DBXzpD eF@HhXpcAp@#qVLk qVM qc#!R[G|S@@Al_qL@Dqwr_@ !Rm?w~@Hc}G[k| !R_vp]Fgp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1002/rcm.9131',
    section: 'conclusion',
    description: 'scheme 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'CO Elimination',
    rxnCode:
      'gCaA@IRWhCZZLtLG~s@!fHT`P eFHPfzND#Qg@ Qp Qd#!R?g?~_xc}G_H\\ !RGYi| !R@AL]nkp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'MassFrontier, need to find literature',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'CO loss',
    rxnCode:
      'gOxaBDYR[fmjj@pb}C@!gJYABCJRkTA}C@ eFHPfzND#qbqkx qq_h Qd#!RupKW_Wx@iJSkiNndG^KB !R_rq?Dw|l_qL]zop !R_rp]~op',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1038/s41598-019-42777-8',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'COOH loss',
    rxnCode:
      'gOxaBDYR[fmjj@pb}C@!gBXA@IReYj@` eMDARVCzX@#qbqkx qi{ Qg#!Rb@I~@Ha}HKjzG{h_GPhB !R_`@@_`A~GUhB !R_rq?Dqvz_@',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1038/s41598-019-42777-8',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'DB rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvCzX@#Q[ Q^#!R_qL@DqtjO@ !R@AM?DquZO@',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1016/j.jpha.2016.04.008',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dioxolane fragmentation',
    rxnCode:
      'detDB@jYRfUwJxZB@h@H!eFHBJD daDHB@RTfUVyiZPB#IaLJfxYT Ql IXdziEP#!Rim~?Sk]}bGwMs?y??g~H_Xa}GSKl !R@AL]fgp !RbOuh{IE?hJUDZpio`CX]Aep',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1039/C3AY40543E',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJPaAaJTkTHGyZCDTDD@cHHA@!eMDiicXOfabKHHAB``D@ eF@HhP#qbqh qTH qu#!RupJH@gx@bGt]\\hH !R_qL@XqwZO@ !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@IRmhCzB@!eF``fJGtX eF@HhP#qTq QX qq#!R_vp@[@@SG_I| !R@AL]Vgp !R@AL]^kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJXA@IRmZ`OdHL@!eM`bfN`~b@ eF@HhP#qTqh Q^ qi#!R_qL@DpAl@AL]Bkp !R_qL@DqwZo@ !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@Icu@_PP!fH@H eM``fM`~b@#qTq qH Q[#!Rm?w~@Hc}GWK| !RG[i| !R_qL@DquZ_@',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Elimination',
    rxnCode:
      'gC`@Dij@~b`!eF@Hp_Q@ eF@HhP#qVa qq Qd#!R@Fq?[@@SGXhB !R@AL]ngp !R@AL]fkp',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1016/j.jpha.2016.04.008',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Elimination (missing source)',
    rxnCode: 'eM`AIhOdq`!fJ@Gup eF@HhP#Qv Qp Qd#!R_vq?Dqwr_@ !RG[i| !R@AL]fkp',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'To check',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Hydrogen elimination',
    rxnCode:
      'gFpACJTj[ATA}C`!gFpAAJTjZ@@A@#qbqk qn\\J#!R_g~w_K_}mwvw_AurO@ !R_g~w_K_}mwvw_AuZO@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eM@bXzCzh@!fHT`P eF@HhP#Q^ a` Q\\#!R@AM?DquJo@ !RGQi| !R@AL]nkp',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1093/chromsci/43.2.92',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eM`BN`~b|b`!eM``fN`~cP#Qg Qg#!R_qL@DqvJ_@ !R_qL@DqwZ_@',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eMHBN`~axp``D_yE@!eMH`fN`~bxp``D@#Qg Qg#!R_qL@DqvJ_@ !R_qL@Dqtz_@',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGt[dT!eF``fLFD@#Qd Qd#!R@AL]Rgp !R@AL]vop',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWFDD@cHh!eFH`fLGt[FDD@`#Qd Qd#!R@FL]Rgp !R@FL]vgp',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'gCh@IGZ@~d^Lf\\@`D_yIP!gChAIIcm@_RWFSN@PB@#qTq qTq#!Rm?w~@Hc}G_I| !Rm?w~@Hc}G]i|',
    ionization: 'esiPositive',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'gC``@deZ@~P]OdE@!gC`a@aJRm@_PV#qJf qJf#!RPAM@G@AcGXi| !RPAM@G@AcG[i|',
    ionization: 'esiPositive',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Oxonium Resonance',
    rxnCode: 'eFH`fJGtQFDD@`!eFHhfLGuQFdD@`#QX Qd#!R@FL]bgp !R_qp]Vop',
    ionization: 'esiPositive',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Rearrangment a',
    rxnCode:
      'dnD@BLeJV|jfZih@`!gOpAGJTju`@@D#qTuYx qigSp#!RKF\\_YUMg_?{~_?y?G_I\\ !Rw|XxCFvp?`@RlD\\LG]kB',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1016/j.comptc.2016.07.018',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Rearrangment d',
    rxnCode:
      'gOpAIJUKua@@Gtt@!gOpAMJUKua@@D#q]gJp q\\oQp#!R_`CW_Xa}u?sW?M]}GPhB !Ru{u~@Hb}upKW@gx@GShB',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1016/j.comptc.2016.07.018',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Tropylium fragmentation',
    rxnCode:
      'gOpAGJTju`@@D!gKPACJTnLE@P eF@HxP#qqUcx qMsx Qd#!R{xXxCBvpo`AblGlLG[KB !RKrV~@FLXKvh]FhH !R@BL]^kp',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'http://people.whitman.edu/~dunnivfm/C_MS_Ebook/CH6/6_9_5.html',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Tropylium fragmentation',
    rxnCode:
      'gFpAAJTjZ@@A@!gBPAAJTkRpD eF@HxP#qbqk qbu qY#!RtCvwOSy?Og~wOQurW@ !R@Cx~Gsx_GUj| !R@DL]^kp',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'https://en.wikipedia.org/wiki/Fragmentation_%28mass_spectrometry%29',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Tropylium rearragement',
    rxnCode:
      'gOpAMJUKua@@Gtt@!gOpAGJTju`@@Gt\\@#qgVMX qYoTp#!Ryst~@H`}y?sg?Cx@GPhB !ROg}GUD]swqg_AlvOGUh|',
    ionization: 'esiPositive',
    reaction: 'Rearrangement',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gCiALAJRu@_HYlgHE@!fI@Gu` eO``fNZ`~cIrE@#qNT qH Qg#!R@FL@[@AcGPj| !RG]i| !R_g~w?Qwzo@',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMH`eIXOda`!fI@Gu` eF@bXhP#Qy Qp Qd#!R@Fp@XqtJ_@ !RG]i| !R@FL]^gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'alpha cleavage',
    rxnCode: 'eM``eIhOh`!fH@Oj@ eF``fJD#Qg Qp Qd#!RPNp@Pqur_@ !RGUi| !R@p@]nop',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1149/1945-7111/abdde7',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Elimination',
    rxnCode: 'eMHAIhOdm`!fI@Guh eF@HhP#Qg a` Qt#!R@Fp@XqvJ_@ !RG]i| !R@FL]^kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Halide Elimination',
    rxnCode:
      'eMBGDchOjbLiDX`!fHfHA}QFRHq@ eF@HhP#Q[ Qp Qd#!R_qL@TqurO@ !RGUi| !R@FL]^kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHbeIXH eFHBLGtX#qrLh Qv qM#!R`W~GkQSuavH]tep !R`W}LeQvZW@ !R_rP]^op',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC`a@eJSM@_QX eF@HhP#satpj satp qi#!RbOrH_Wx@b@JH_QtJ`` !Rb@JH_Wx@GSjB !R_rp]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 12',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC``@dfZ@~b` eF@bXpP#qbqk qbq qk#!RbOrH_Wx@b@JH_Qwr`` !Rb@JH_Wx@GSjB !R@FL]~kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 13',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSJuPGtT@!gC``@deZ@` eF@bXpP#qbqk qbu qK#!R_`CW?Hc|uwvH_QwR`` !R@FL@[@AcGSj| !R_rp]~op',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 14',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gJXaLDiRYZ`Ohh@!eMhdiRVB eFHBLGtP#qbqh qbH qu#!RbOvH@oy?bOt]Bmp !R@Fp@DqwZ?@ !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 16A & B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gJYIC`DBTijXCzB@!eMhdiRVB eFB@HcA}D@#qbqh qJh Ql#!Rb@Jw@ox@bOt]\\hH !R@Fp@DqwZ?@ !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 19',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'daF@B@BTeeVz`@@B!gOpAMJUKua@@D fJRPH#IGfbdK@ q\\oQp ID#!RmpJw?_y?mpJw?[_}mpH]Dcp !Rmww~@Ha}mpJw@ox@GUk| !RG_i|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'did@BLeJeWk``b@CzAbLMcApB@!gOpAMJUKua@@D eF@HhXqcApB@#IZJyBGI q\\oQp IFP#!Ri}w^@Hc]i?rg@h`Bw`BHwQur@` !Ri}w^@Hc]i?rg?Mx@G]hB !R@@L]Agp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'dif@B@BTeYWaz@@@OhB@!gOpAMJUKua@@D eF`BND#Id^ZJPl q\\oQp IdP#!R?`C~@K\\Bmww~@K\\BmpK~@AuRh` !Rmww~@Ha}mpJw@ox@GUk| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'didHB@BTiyWaj@@@OhB@!gOpAMJUKua@@D eFHBLGtP#IGiZJPl q\\oQp IFP#!Rm?vH?[\\Bm?w~@K\\BmpK~@Awb@` !Rmww~@Ha}mpJw@ox@GUk| !R_vp]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'dmtDB@PIRY^UeVj@@@OhB@!gOpAMJUKua@@D gC``@deZ@`#IaLJfxYWP I[aJUt qbu#!R?`Bw@h`Bm?vH?Xc|?g~H?Xa}?g|]LhH !Rm?w~@Hc}mpJw@ox@GUk| !R@AL@[@@SGXY|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gGYIC`DBTiff`OhH@!gCiIL`DBTff@~`p eF@HhP#IaLJa qbM IG@#!RmpJH@k_}?`BH?Qtr`` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 20',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gNyIC`DF\\dTJij@~a`!gJYHC`DISTpGtL@ eF@bXpP#IaLJnD qbqh IxP#!Rb@Jw@ox@bOvH@hc}GWJB !Rb@Jw@ox@bOt]NhH !R@AL]Agp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 21',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gGYIC`DB\\dTMM@_PP!gCaHL@aJZPH eF``fJGtP#qbqo qbq qo#!RbOvw?_y?b@JH?Qvrw@ !R@Fq?[@@SG]i| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 22',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGrDZHpypB@P!gCh@@eKHFLv\\@`D@ eF``fLGtX#qn\\J qfQ qk#!RbOvw?X`B?g~H?Qurw@ !R_?xBbG?~GYk| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 23',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGtFQas`D@`!gChAAIRfdCF[N@PB@ eF`BLGtX#qj|^ qbs qo#!Rm?vH?[\\B?g~w?QvRw@ !R@Fq?[@@SG]k| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 26',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTfUfjX@~QLr@!gJU@E`dru@_SX eMHbeIXH#IZbyAr@ IZnHP Qv#!R_`CW?Hc|uwvH_Wx?u?p]dhH !R_`BH?M_|bGt]vhH !R_rq?Dqwz?@',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 28',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gChA@IRfhB!eF`BLD eF@bXpP#qLZ qK Qd#!RhBr^_zA]GPj| !R@Gt]Vgp !R_uP]nop',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTf[VjX@~QHr@!gGTaEaUJSNuHGrVZ@ eF@HhP#IaLJfEP IaLJa IU`#!Rb@JH?_x@?g~H@k_}bOt]|gp !Rb@JH?_x@b@JH?QtF`` !R@AL]fkp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 30',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode: 'eMH`eIXOh`!fH@Oj@ eFHbfJD#Qg Qp Qd#!R@Fp@Dqwr_@ !RGWi| !R@AL]Vkp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode:
      'eMH`eIXOh`!fHT`P eMHAIXOj`#qNP QP qN@#!R@Fp@Dqwr_@ !RGWi| !R@Fp@DqwZ?@',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 32',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode: 'eMH`fN`~b@!fHT`P eFHBLGtP#Qg QP Ql#!R_qL@Dqur_@ !RG[i| !R@AL]Vgp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 33',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'gCaA@IRfhCiQs{BIF`!eFH`fLGtX eF@HhP#qVa QX qN#!R@Fq?[@@SGXk| !R@AL]vgp !R@AL]~kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 34',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gNpYHlQxR\\ddqZj@~Tap!gJPYHlQxRX}j@~TaP eF@HhP#qbuKx qbqh q{#!RDw|@Dw}l[@@@[@@SGPi| !Rm?w~@Oy?bOt]vgp !R@AL]Akp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 37A&B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gGPYHlQxJTjmj`Ohh@!gCaiHlO@SGZ@` eFHBLGtP#IaLJa qbi IpP#!R[G|@[G|SDp@@Dqvr_@ !Rm?w~@Hc}GUk| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 38',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gChA@IRfhCyBM@!eF``fLGtX eF@HhP#qbq Ql qQ#!R@Fq?[@@SGPi| !R@AL]vgp !R@AL]~kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 4 ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gGQeEb@b^BeIiZhCzJ@!gC`eE`DSpdiLtA@ eFHBLGtP#qbqk qbM qs#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Hc}G]jB !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 45',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'gNqeEb@b^BgHiDVj`Ohh@!gJQeEb@b^BeIij@~bp eF@HhP#qbqkx qbqh q_#!R[@@@Dw}l[@@@[@@SGPiB !Rb@K~@Oy?bOt]N`H !R@AL]~kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 46',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gGQeLZ@b^@eJZihCzB@!gJQdEb@b^BSTtA}A@ fHT`P#qbqk qbMX Qp#!R_qL@Dvq?_qLS@AtrO@ !Rb@K~@Oy?bOt]v`H !RGWi|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 49',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gJXA@IRij`OhH@!gChA@Icm@P fH@Oj@#qrM` qri a`#!Rm?w~@Hc}mpH]Lop !Rm?w~@Hc}GUk| !RGWi|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 5',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gNqeLZ@b^@eJZZZ`OhH@!gJQeEb@b^@eIjZ@~`p eF@HhP#qbqkx qbMX q~#!R_vp@[AM?_vql@@@SGSHB !Rb@K~@Oy?bOt]N`H !R@AL]~kp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 50',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'gGQeLZ@b^@eJZihCzB@!gCaiHlO@SGZ@` eFB@HcA}D@#qbqk qQ] Ql#!R_qL@Dvq?_qLS@AwRO@ !Rm?w~@Hc}GUk| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 51',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gJPlLPDSpPPdtu@_QP fHT`P#qbqk qbqh qX#!RDp@@[G|SDp@@DqvrP` !Rb@K~@Oy?bOt]v`H !RGWi|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 52',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gC`eE`DSpdiLtA@ eFB@HcA}D@#qbqk qbM qs#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Hc}G]jB !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 53',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'gGPmLPDSpPPiRZVj@~b`!gJPmLPDSpPQIRZV`H fH@Oj@#q`qk qpeH qX#!RDp@@[G|SDp@@DqtrP` !Rb@K~@Oy?bOt]v`H !RG_i|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 54',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'gGXiMDOCSddajXCFEA@H@!gC`iHaxBX}HFLrB@P eF`BLD#qbqk qbu qK#!RDpA?DpAl[G|@Dqvr_@ !Rm?w~@Hc}GUk| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 55',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'dazDbLa@|LeJi~ij@OdrNbLD``D@!gC`hHaxQvPOhHcL``D@ eF``fLGtX eF@HxP#IaLJnXP qbu qK IxP#!R@ALS@G|S[@@@[G}l@AL]top !Rm?w~@Hc}GUk| !R@AL]^gp !R@AL]Qkp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 56',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'gNxiMDOCSddauSPGrtNHphHA@!gJXiMDOCSGuHGtvQaPPB@ eF@HhP#qbqkx qbqh q_#!R[@A?[@@SDw|@[@@SG_I| !Rm?w~@Oy?bOt]Ngp !R@AL]Akp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 57',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminodithiophosphate fragmentation',
    rxnCode:
      'gGYMC`DSphPIRfji@~`bLjB@P!gCiEEAxXHDqzPLYdD@` eFB@HcA}D@#qrYl qQl qs#!R_qL@Dw|SDpAl_qwRO@ !R?`BH?[_}GUk| !R@AL]~gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 58',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonates fragmentation',
    rxnCode:
      'gJQiHlOBSGmPGtd@!gCahHlOBOTA}I@ fHT`P#qbqh qbq qh#!Rm?w~@Oy?bOt]Lgp !Rm?w~@Hc}GUk| !RGWi|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 59',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gGXiMD@cSddaVhCz[@!gC`iH`DBXzpD eF`BLGtX#qqj\\ qqk QX#!R[@@cWu}l@BM_HquR_@ !Re{vHo[x@GYk| !R_tp]^gp',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 63',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfites fragmentation',
    rxnCode:
      'gJQiHl@aReVu@_QP!gCahHl@bNtA}E@ fHT`P#qbqh qbq qh#!RmpJH@oy?bOt]lkp !Rm?vH?_x@G]k| !RG_i|',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 68',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gCiADEJSM@P!fHT`P eMhDRVB#qbq qH Qg#!Rb@K~@Hc}G_JB !RG[i| !R@Fp@DqwZ_@',
    ionization: 'eiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 8',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Water elimination',
    rxnCode: 'eFH`fLGtX!fI@Gu` fHT`P#QX QP a`#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: '',
    rxnCode:
      '#KaaGQgJv^zk KpL|}k sNt^O#!RbGvw__x@bOs~_{\\BmpJH_Xa}?`C~_quro@ !R?g~w@k_}m?vw@auzO@ !R?g~w@k_}m?vw@avZO@',
    ionization: '',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: '',
    web: '',
    mode: '',
    isbn: '',
  },
];
